module.exports = __webpack_public_path__ + "static/media/UNIVERSIDADE_NOVA.d07a320a.svg";